export default "__VITE_ASSET__B446ZJhM__"